import { push } from "../Services/Analytics"

var textToShare = "ספרו לנו על הדבר הכי מטורף שעשיתם כדי לצפות במשחק מהמונדיאל, ואולי תזכו ב-300 שקלים לקניות בסופרמרקט אונליין של BringBring";
var urlToShare = "https://z.ynet.co.il/mlong/commerce/2018/bringbringlead/";

const shareFacebook = () => {
    push("Share_Facebook", urlToShare);
    window.open("http://www.facebook.com/share.php?u=" + encodeURIComponent(urlToShare), "_blank");
}

const shareTwitter = () => {
    push("Share_Twitter", urlToShare);
    window.open("https://twitter.com/intent/tweet?text=" + encodeURIComponent(window.document.title) + "&url=" + encodeURIComponent(urlToShare), "_blank");
}

const shareWhatsapp = () => {
    push("Share_WhatsApp", urlToShare);
    window.open("whatsapp://send?text=" + encodeURIComponent(textToShare + " >> " + urlToShare), "_parent");
}

const openNegishut = () => {
    push("Accessibility", "Open_Accessibility_Clicked");
    window.document.getElementById('INDmenu-btn').click();
}

export {
    shareFacebook,
    shareTwitter,
    shareWhatsapp,
    openNegishut
}


// WEBPACK FOOTER //
// ./src/Components/Services/Sharing.js